import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RejectionReasonList } from '../../../../components/admin-dashboard-component/rejection-reasons/rejection-reason-list/rejection-reason-list';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-view-all-rejection',
  standalone: true,
  imports: [RejectionReasonList, RouterLink],
  templateUrl: './view-all-rejection-reasons.html',
  styleUrl: './view-all-rejection-reasons.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewAllRejectionReasons {}
